/**
 * Whether a survey still asks anything: at least one non-archived question.
 * Read the survey with `survey_questions(archived_at)`. A survey whose
 * questions are all archived cannot be answered, so it never blocks a
 * certificate.
 */
export function hasLiveQuestions(survey: { survey_questions?: { archived_at: string | null }[] | null }): boolean {
  return (survey.survey_questions ?? []).some((q) => !q.archived_at);
}
